module.exports = __webpack_public_path__ + "img/sleeve binding length.25cd9618.png";